import { UIActionIcon, UIActionType } from '@common/modules/insights/interfaces';
import { ActionButtonType } from '@common/modules/shared/components/action-button/interfaces';
import { IAction } from '@common/modules/shared/interfaces';

export const manageAiInsightsAction: IAction = {
  icon: UIActionIcon.SETTINGS,
  id: 'manage-ai-insights',
  key: 'ManageAiInsightsButtonTitle',
  buttonType: ActionButtonType.HEADER_BUTTON,
  value: ''
};

export const importAction: IAction = {
  icon: UIActionIcon.DOWNLOAD,
  id: 'export',
  key: 'Import',
  buttonType: ActionButtonType.PRIMARY,
  value: 'Import'
};

export const menuAction: IAction = {
  icon: 'i-vi-menu',
  key: '',
  value: UIActionType.MENU,
  id: 'extension-menu'
};

export const menuActionList: IAction[] = [
  {
    icon: 'i-vi-view',
    title: 'View details',
    key: 'ViewDetails',
    value: UIActionType.INFO,
    type: UIActionType.INFO,
    selectable: true,
    id: 'view-extension-details'
  }
];

export const openConnectedCluster: IAction = {
  title: '',
  type: UIActionType.OPEN_IN_NEW_TAB,
  value: UIActionType.OPEN_IN_NEW_TAB,
  key: 'EdgeCantLoadExtensionButtonTitle',
  icon: UIActionIcon.OPEN,
  selected: false,
  selectable: true,
  id: 'openConnectedCluster'
};
